module.exports = __webpack_public_path__ + "img/portrait-065.3eb92aff.jpg";